var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOntimeDeliveryKpi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40840",
    d: "M1 19H39V33C39 36.3137 36.3137 39 33 39H7C3.68629 39 1 36.3137 1 33V19Z",
    fill: "#6BE3A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250695",
    d: "M15 10V1H25V10L20 7L15 10Z",
    fill: "#6BE3A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40841",
    d: "M20 39H7C3.68629 39 1 36.3137 1 33V20V7C1 3.68629 3.68629 1 7 1H11H33C36.3137 1 39 3.68629 39 7V10V22",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250697",
    d: "M31.5 34C31.5 34.2761 31.7239 34.5 32 34.5C32.2761 34.5 32.5 34.2761 32.5 34H31.5ZM32.3536 26.6464C32.1583 26.4512 31.8417 26.4512 31.6464 26.6464L28.4645 29.8284C28.2692 30.0237 28.2692 30.3403 28.4645 30.5355C28.6597 30.7308 28.9763 30.7308 29.1716 30.5355L32 27.7071L34.8284 30.5355C35.0237 30.7308 35.3403 30.7308 35.5355 30.5355C35.7308 30.3403 35.7308 30.0237 35.5355 29.8284L32.3536 26.6464ZM32.5 34V27H31.5V34H32.5Z",
    fill: "#383434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOntimeDeliveryKpi);
export default __webpack_public_path__ + "static/media/Ontime_Delivery_KPI.b262bb2ca7829a2da678e218d67edb03.svg";
export { ForwardRef as ReactComponent };